<template>
  <div class="app-content-container home">
    <div class="app-full-bleed home__top">
      <div class="home__top-text">
        <img src="@/assets/images/mzingo-logo.svg" alt="Mzingo Logo" />
        <div class="home__bold-text">Welcome to Mzingo Partners</div>
        <div class="home__medium-text">
          Connect, Engage, and $upport - Ideas for Real Change
        </div>
      </div>
      <img class="home__top-dotted" src="@/assets/images/combined-shape.svg" />
    </div>

    <div class="img-container img-container--top">
      <img src="@/assets/images/home1.png" alt="word cloud" />
    </div>

    <div class="app-full-bleed home__info-banner">
      <div class="home__small-text">Mzingo Partners Pledge</div>
      <div class="text-container home__text">
        We are here to support growth and prosperity for individuals and their communities. We
        demonstrate this by ensuring means of generosity intersect with needs to succeed. We develop
        the necessary foundations built for success, using today's technology for tomorrow's world.
      </div>
    </div>
    <div class="divider"></div>
    <!-- <div class="home__content">
      <div class="home__text">Verified Projects</div>
      <div class="home__small-text">Browse by Category</div>
    </div>

    <div class="categories">
      <div class="category" @click="routeToCategory(1)">
        <div class="category-icon">
          <font-awesome-icon size="2x" :icon="['fas', 'child']" />
          <font-awesome-icon size="4x" :icon="['fas', 'female']" />
          <font-awesome-icon size="2x" :icon="['fas', 'child']" />
        </div>
        <div class="home__small-text">Women & Children</div>
        <div class="home__learn-more">Learn More</div>
      </div>
      <div class="category" @click="routeToCategory(2)">
        <div class="category-icon">
          <font-awesome-icon size="3x" :icon="['fas', 'house-damage']" />
          <font-awesome-icon size="2x" :icon="['fas', 'sync-alt']" />
        </div>
        <div class="home__small-text">Disaster Recovery</div>
        <div class="home__learn-more">Learn More</div>
      </div>
    </div>
    <div class="categories">
      <div class="category" @click="routeToCategory(3)">
        <font-awesome-icon class="category-icon" size="4x" :icon="['fas', 'chalkboard-teacher']" />
        <div class="home__small-text">Children & Education</div>
        <div class="home__learn-more">Learn More</div>
      </div>
      <div class="category" @click="routeToCategory(4)">
        <font-awesome-icon class="category-icon" size="4x" :icon="['fas', 'plus']" />
        <div class="home__small-text">Health & Sanitation</div>
        <div class="home__learn-more">Learn More</div>
      </div>
    </div>
    <div class="categories">
      <div class="category" @click="routeToCategory(5)">
        <font-awesome-icon class="category-icon" size="4x" :icon="['fas', 'seedling']" />
        <div class="home__small-text">Environment</div>
        <div class="home__learn-more">Learn More</div>
      </div>
      <div class="category" @click="routeToCategory(6)">
        <font-awesome-icon class="category-icon" size="4x" :icon="['fas', 'cogs']" />
        <div class="home__small-text">Micro-Enterprise</div>
        <div class="home__learn-more">Learn More</div>
      </div>
    </div>-->

    <div v-if="dataLoaded && engagements.length > 0">
      <div class="home__content">
        <div class="home__text">Our Engagements</div>
        <div class="home__small-text">
          <router-link :to="{ name: 'ListEngagements' }">See More</router-link>
        </div>
      </div>

      <div class="engagements">
        <router-link
          v-for="engagement in engagements"
          :key="engagement.id"
          :to="{ name: 'EngagementDetails', params: { engagementId: engagement.id } }"
          class="engagement"
        >
          <img :src="engagement.photo" />
          <div class="engagement-content">
            <h5>{{ engagement.title }}</h5>
            <div>
              {{ engagement.shortDescription }}
            </div>
            <div class="is-centered">
              <button class="small-button">Learn More</button>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div v-if="dataLoaded && engagements.length > 0" class="divider"></div>

    <div class="home__content">
      <div class="text-container home__text">
        Explore and learn more, engage people and their projects, and don't forget to dream big and
        share your ideas
      </div>
      <div class="home__subcontent">
        <div>
          <div class="home__small-text">Browse All Projects</div>
          <router-link :to="{ name: 'SearchProjects' }">See More</router-link>
        </div>
        <div>
          <div class="home__small-text">Create A Project</div>
          <router-link :to="{ name: 'MakerOnboarding' }">Learn More</router-link>
        </div>
      </div>
    </div>

    <div class="divider" style="margin-bottom: 2.5rem;"></div>

    <div class="img-container img-container--bottom">
      <img src="@/assets/images/home2.jpg" alt="Mzingo Partner" />
    </div>

    <div class="app-full-bleed home__bottom">
      <div class="home__bottom-text">
        <div class="home__bold-text" style="margin-bottom: 1rem;">Moving Forward Together</div>
        <div class="text-container home__medium-text" style="margin-bottom: 1rem;">
          We believe we all can do better at doing good, so we welcome all forms of support and all
          ideas about ways to achieve this.
        </div>
        <!-- Mzingo changes -->
        <!--
        <button class="small-button" @click="routeToHowToEngage">Learn More</button>-->
      </div>
      <img class="home__bottom-dotted" src="@/assets/images/combined-shape.svg" />
    </div>
  </div>
</template>

<script>
import Engagement from '@/services/engagements'

export default {
  name: 'Home',
  data() {
    return {
      engagements: [],
      dataLoaded: false,
    }
  },
  created() {
    this.refreshData()
  },
  methods: {
    routeToHowToEngage() {
      window.location.href = 'https://changefunder.org/engage'
    },
    routeToCategory(id) {
      this.$router.push({ name: 'SearchProjects', params: { buttonId: id } })
    },
    /** Google Analytics - Send "Click 'Create a Project'" event to GA. */
    sendCreateProjectEventGA() {
      this.$ga.event({
        eventCategory: "Click 'Create a Project'",
        eventAction: 'From Home Page',
      })
    },
    refreshData(page = null) {
      this.dataLoaded = false

      let engagementPromise = Engagement.api.list({ filters: { page } }).then(data => {
        this.engagements = data.results
        this.engagements.splice(3)
      })

      Promise.all([engagementPromise])
        .then(() => {
          this.dataLoaded = true
        })
        .catch(() => (this.dataLoaded = true))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/layout';
@import '../styles/forms';
@import '../styles/variables';
@import '../styles/mixins/buttons';

.home {
  &__top {
    background-color: $primary;
    height: 330px;
    position: relative;
  }
  &__top-dotted {
    height: 220px;
    top: 100px;
    position: absolute;
  }
  &__top-text {
    text-align: center;
    width: 100%;

    img {
      display: inline-flex;
      height: 75px;
      margin: 1.5rem 0;

      @media screen and (min-width: 900px) {
        height: 90px;
      }
    }
  }
  &__bold-text {
    color: white;
    font-weight: 900;
    font-size: 22px;
  }
  &__medium-text {
    color: white;
    font-size: 14px;
    line-height: 1.5;
    letter-spacing: normal;
    margin: 1.5rem 5rem;
  }

  &__info-banner {
    background-color: $white-smoke;
    margin: 2rem 0;
    padding: 8px 16px 16px;
    line-height: 1.21;
  }

  &__content {
    margin: 1.5rem auto;
  }
  &__subcontent {
    display: flex;
    text-align: center;
    justify-content: space-evenly;
    margin: 1.5rem;
  }

  &__small-text {
    text-align: center;
    font-weight: bold;
    font-size: 12px;
    margin: 10px;
  }
  &__text {
    font-size: 15px;
    text-align: center;
    line-height: 1.21;
  }
  &__learn-more {
    color: $accent-inverted;
    font-size: 12px;
  }

  &__bottom {
    background-color: $accent;
    height: 380px;
    position: relative;
    margin-top: -160px;
  }
  &__bottom-dotted {
    height: 220px;
    position: absolute;
  }
  &__bottom-text {
    bottom: 30px;
    position: absolute;
    text-align: center;
    width: 100%;
  }
}

.white-text {
  color: white;
}

.divider {
  border-bottom: 2px solid $white-smoke;
  width: 90%;
  margin: auto;
}

.text-container {
  max-width: 532px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}

.img-container {
  display: block;
  width: 90%;

  img {
    display: block;
    width: 100%;
    margin: 0 auto;

    position: relative;
    z-index: 50;
  }

  &--top {
    margin-top: -90px;
  }

  &--bottom {
    img {
      max-width: 600px;
    }
  }
}

.categories {
  display: flex;
  padding: 0 2rem;
  justify-content: center;
}

.category {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  margin: 1rem;
  padding: 1rem 0 2rem;
  text-align: center;
  border-radius: 8px;
  background-color: rgba($primary, 0.7);
  color: white;
  cursor: pointer;

  img {
    width: 60px;
    margin: 1.5rem auto;
  }

  &-icon {
    margin: 1.5rem auto;
    color: $accent-inverted;
  }
}

.full-width-card {
  padding: 1.25rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
  border: 0;
}

a {
  color: $primary;
  font-size: 12px;
}

.engagements {
  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: 700px;
  margin-left: auto;
  margin-right: auto;

  .engagement {
    position: relative;
    overflow: hidden;

    height: fit-content;
    width: 90%;

    display: flex;
    align-items: center;
    justify-content: center;

    margin: 0 1rem 2rem;

    img {
      position: absolute;

      display: block;
      width: 100%;
      min-height: 100%;
      object-fit: cover;

      filter: blur(4px);
      -webkit-filter: blur(4px);
    }

    &-content {
      position: relative;

      width: 100%;
      height: 100%;
      padding: 2rem 2rem 0.5rem;

      font-size: 15px;
      line-height: 1.21;
      color: white;
      background-color: rgba(black, 0.6);

      h5 {
        color: white;
      }
    }
  }
}

@media only screen and (max-width: $mobile-smallest-width) {
  .home {
    &__bold-text {
      font-size: 18px;
    }
    &__medium-text {
      margin: 1.5rem 2rem;
    }

    &__info-banner {
      padding: 6px 50px;
    }
  }

  .categories {
    flex-direction: column;
    padding: 0 3rem;
  }
}
</style>
